module.exports = __webpack_public_path__ + "static/media/mc_tube_rotor.ee2d1bc4.svg";